/**
 * 网络请求轮询工具类
 */
export  default class TaskPoller {
  constructor(requestFn, interval = 1000, maxDuration = 20000) {
    this.requestFn = requestFn;     // 传入的请求函数 (需返回 Promise)
    this.interval = interval;       // 间隔时间 (ms)
    this.maxDuration = maxDuration; // 最大持续时间 (ms)
    this.timer = null;
    this.startTime = null;
  }

  /**
   * 开始执行轮询
   * @param {Function} onProgress 每次请求响应的回调函数
   * @returns {Promise} 最终成功或失败的状态
   */
  start(modelId,onProgress) {
    return new Promise((resolve, reject) => {
      this.startTime = Date.now();

      const execute = async () => {
        // 1. 检查是否超时
        const elapsed = Date.now() - this.startTime;
        if (elapsed >= this.maxDuration) {
          this.stop();
          reject(new Error("Timeout: 执行超过20秒未成功"));
          return;
        }

        try {
          // 2. 执行网络请求
          const response = await this.requestFn(modelId);
          const status = response?.data?.status;
          const isSuccess = response?.success === true;
          console.log("getDownloadStatus:response", JSON.stringify(response));

          // 3. 只有成功时才 resolve
          if (isSuccess && status === 'success') {
            this.stop();
            onProgress && onProgress({ status: 'success', data: response });
            resolve(response);
            return;
          }

          // 4. 其他状态只响应 onProgress，继续轮询
          onProgress && onProgress({ status, data: response, isSuccess });
          this.timer = setTimeout(execute, this.interval);

        } catch (error) {
          // 5. 请求异常时只响应 onProgress，继续轮询直到超时
          onProgress && onProgress({ status: 'error', error });
          this.timer = setTimeout(execute, this.interval);
        }
      };

      execute();
    });
  }

  /**
   * 停止轮询
   */
  stop() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}